$(window).scroll(function(){

	// Add parallax scrolling to all images in .paralax-image container
	$('.parallax-image').each(function(){
		// only put top value if the window scroll has gone beyond the top of the image
		if ($(this).offset().top < $(window).scrollTop()) {
			// Get ammount of pixels the image is above the top of the window
			var difference = $(window).scrollTop() - $(this).offset().top;
			// Top value of image is set to half the amount scrolled
			// (this gives the illusion of the image scrolling slower than the rest of the page)
			var half = (difference / 2) + 'px';

			$(this).find('img').css('top', half);
		} else {
			// if image is below the top of the window set top to 0
			$(this).find('img').css('top', '0');
		}
	});
  
  	// Add parallax scrolling to all images in .paralax-image container
	$('.parallax-video').each(function(){
		// only put top value if the window scroll has gone beyond the top of the image
		if ($(this).offset().top < $(window).scrollTop()) {
			// Get ammount of pixels the image is above the top of the window
			var difference = $(window).scrollTop() - $(this).offset().top;
			// Top value of image is set to half the amount scrolled
			// (this gives the illusion of the image scrolling slower than the rest of the page)
			var half = (difference / 2) + 'px';

			$(this).find('video').css('top', half);
		} else {
			// if image is below the top of the window set top to 0
			$(this).find('video').css('top', '0');
		}
	});
});

jQuery( document ).ready(function() {
  	
  	jQuery('#shopify-section-81ca90f8-edf2-409c-b340-cbef9337fbe0').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-81ca90f8-edf2-409c-b340-cbef9337fbe0').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-81ca90f8-edf2-409c-b340-cbef9337fbe0').find('.caption-content').removeClass('bounceInLeft');
  	
  	jQuery('#shopify-section-8a6bfa6e-7111-4317-bb50-17984e1cc554').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-8a6bfa6e-7111-4317-bb50-17984e1cc554').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-8a6bfa6e-7111-4317-bb50-17984e1cc554').find('.caption-content').removeClass('bounceInLeft');
  	
  	jQuery('#shopify-section-1590566327262').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-1590566327262').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-1590566327262').find('.caption-content').removeClass('bounceInLeft');
  
  	jQuery('#shopify-section-b6c6f33b-c628-401c-a826-37d823c4c119').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-b6c6f33b-c628-401c-a826-37d823c4c119').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-b6c6f33b-c628-401c-a826-37d823c4c119').find('.caption-content').removeClass('bounceInLeft');
  
  	jQuery('#shopify-section-4d4149e6-a940-4eb5-a6af-d6a1c2428f39').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-4d4149e6-a940-4eb5-a6af-d6a1c2428f39').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-4d4149e6-a940-4eb5-a6af-d6a1c2428f39').find('.caption-content').removeClass('bounceInLeft');
  
  	jQuery('#shopify-section-3a725cf5-0360-491f-bdd4-85b6034f0ea0').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-3a725cf5-0360-491f-bdd4-85b6034f0ea0').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-3a725cf5-0360-491f-bdd4-85b6034f0ea0').find('.caption-content').removeClass('bounceInLeft');
  
  	jQuery('#shopify-section-1590225564117').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-1590225564117').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-1590225564117').find('.caption-content').removeClass('bounceInLeft');
  	
  	jQuery('#shopify-section-1600956370680').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-1600956370680').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-1600956370680').find('.caption-content').removeClass('bounceInLeft');
  
  	jQuery('#shopify-section-a662968a-ca14-4aba-990b-38e9253514d9').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-a662968a-ca14-4aba-990b-38e9253514d9').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-a662968a-ca14-4aba-990b-38e9253514d9').find('.caption-content').removeClass('bounceInLeft');
  
  	jQuery('#shopify-section-c7967835-830f-44fc-849d-cda4ab7d2ae7').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-c7967835-830f-44fc-849d-cda4ab7d2ae7').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-c7967835-830f-44fc-849d-cda4ab7d2ae7').find('.caption-content').removeClass('bounceInLeft');
  
  	jQuery('#shopify-section-b518688d-6737-4fae-adcb-56ef9fdc3cf7').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-b518688d-6737-4fae-adcb-56ef9fdc3cf7').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-b518688d-6737-4fae-adcb-56ef9fdc3cf7').find('.caption-content').removeClass('bounceInLeft');
  
  	jQuery('#shopify-section-c485483f-83bf-452e-a6ae-7228d4b1d7e2').find('.caption-content').addClass('slow go');
  	jQuery('#shopify-section-c485483f-83bf-452e-a6ae-7228d4b1d7e2').find('.caption-content').removeClass('animated');
  	jQuery('#shopify-section-c485483f-83bf-452e-a6ae-7228d4b1d7e2').find('.caption-content').removeClass('bounceInLeft');
  	
  	jQuery('#shopify-section-1600978896940').hover(
      function(){
          // console.log("S");
          jQuery(this).addClass('width28');
          jQuery("#shopify-section-1600979165718").addClass('width18');
          jQuery("#shopify-section-1600979286575").addClass('width18');
          jQuery("#shopify-section-1600979447350").addClass('width18');
          jQuery("#shopify-section-1601056160070").addClass('width18');
      },
      function () {
          jQuery(this).removeClass('width28');
          jQuery("#shopify-section-1600979165718").removeClass('width18');
          jQuery("#shopify-section-1600979286575").removeClass('width18');
          jQuery("#shopify-section-1600979447350").removeClass('width18');
          jQuery("#shopify-section-1601056160070").removeClass('width18');
      }
    );
  
  	jQuery('#shopify-section-1600979165718').hover(
      function(){
          console.log("S");
          jQuery(this).addClass('width28');
          jQuery("#shopify-section-1600978896940").addClass('width18');
          jQuery("#shopify-section-1600979286575").addClass('width18');
          jQuery("#shopify-section-1600979447350").addClass('width18');
          jQuery("#shopify-section-1601056160070").addClass('width18');
      },
      function () {
          jQuery(this).removeClass('width28');
          jQuery("#shopify-section-1600978896940").removeClass('width18');
          jQuery("#shopify-section-1600979286575").removeClass('width18');
          jQuery("#shopify-section-1600979447350").removeClass('width18');
          jQuery("#shopify-section-1601056160070").removeClass('width18');
      }
    );
  
  	jQuery('#shopify-section-1600979286575').hover(
      function(){
          console.log("S");
          jQuery(this).addClass('width28');
          jQuery("#shopify-section-1600978896940").addClass('width18');
          jQuery("#shopify-section-1600979165718").addClass('width18');
          jQuery("#shopify-section-1600979447350").addClass('width18');
          jQuery("#shopify-section-1601056160070").addClass('width18');
      },
      function () {
          jQuery(this).removeClass('width28');
          jQuery("#shopify-section-1600978896940").removeClass('width18');
          jQuery("#shopify-section-1600979165718").removeClass('width18');
          jQuery("#shopify-section-1600979447350").removeClass('width18');
          jQuery("#shopify-section-1601056160070").removeClass('width18');
      }
    );
  
  	jQuery('#shopify-section-1600979447350').hover(
      function(){
          console.log("S");
          jQuery(this).addClass('width28');
          jQuery("#shopify-section-1600978896940").addClass('width18');
          jQuery("#shopify-section-1600979165718").addClass('width18');
          jQuery("#shopify-section-1600979286575").addClass('width18');
          jQuery("#shopify-section-1601056160070").addClass('width18');
      },
      function () {
          jQuery(this).removeClass('width28');
          jQuery("#shopify-section-1600978896940").removeClass('width18');
          jQuery("#shopify-section-1600979165718").removeClass('width18');
          jQuery("#shopify-section-1600979286575").removeClass('width18');
          jQuery("#shopify-section-1601056160070").removeClass('width18');
      }
    );
  
  	jQuery('#shopify-section-1601056160070').hover(
      function(){
          console.log("S");
          jQuery(this).addClass('width28');
          jQuery("#shopify-section-1600978896940").addClass('width18');
          jQuery("#shopify-section-1600979165718").addClass('width18');
          jQuery("#shopify-section-1600979286575").addClass('width18');
          jQuery("#shopify-section-1600979447350").addClass('width18');
      },
      function () {
          jQuery(this).removeClass('width28');
          jQuery("#shopify-section-1600978896940").removeClass('width18');
          jQuery("#shopify-section-1600979165718").removeClass('width18');
          jQuery("#shopify-section-1600979286575").removeClass('width18');
          jQuery("#shopify-section-1600979447350").removeClass('width18');
      }
    );
  
  	jQuery('#shopify-section-f29f5ad3-071a-43da-b66a-bf4e38e80623 h3').replaceWith(function () {
        return "<h2 class='image-with-text__heading text-align-center is-regular'>" + jQuery(this).html() + "</h2>";
    });
  	jQuery('#shopify-section-35b9ce81-f0d3-45c2-a597-3309e1ae9776 h3').replaceWith(function () {
        return "<h2 class='image-with-text__heading text-align-center is-regular'>" + jQuery(this).html() + "</h2>";
    });
  	jQuery('#shopify-section-a3b0d483-f6de-431a-805d-6cf905feb63c h3').replaceWith(function () {
        return "<h2 class='image-with-text__heading text-align-center is-regular'>" + jQuery(this).html() + "</h2>";
    });
  
  	jQuery('#shopify-section-1559243878715 h3').replaceWith(function () {
        return "<h2>" + jQuery(this).html() + "</h2>";
    });
  
  	jQuery('#shopify-section-1559243981492 h3').replaceWith(function () {
        return "<h2>" + jQuery(this).html() + "</h2>";
    });
  
  	jQuery('#shopify-section-1580963144817 h2').replaceWith(function () {
      return "<h3 style='color:#fff !important'>" + jQuery(this).html() + "</h3>";
    });
  
  	jQuery('#shopify-section-1593145830037 .pretext p').replaceWith(function () {
      return "<h2 style='font-size: 20px !important'>" + jQuery(this).html() + "</h2>";
    });
  
  	jQuery('#shopify-section-1590230611862 h2').replaceWith(function () {
      return "<h3 style='color:#fff !important'>" + jQuery(this).html() + "</h3>";
    });
  
  	jQuery('#shopify-section-1590230520107 h2').replaceWith(function () {
      return "<h3 style='color:#fff !important'>" + jQuery(this).html() + "</h3>";
    });
  
  	jQuery('#shopify-section-1590230429422 h2').replaceWith(function () {
      return "<h3 style='color:#fff !important'>" + jQuery(this).html() + "</h3>";
    });
  
  	jQuery('#shopify-section-1590230340821 h2').replaceWith(function () {
      return "<h3 style='color:#fff !important'>" + jQuery(this).html() + "</h3>";
    });
  
  	jQuery("#shopify-section-1590225564117").find("h1").attr('id', 'header_main_h1');
  	jQuery("#shopify-section-1590810860779 video").attr('title', 'Dreame V11 Cordless Vacuum Cleaner - DreameTime - A New Era for Vacuum Cleaner');
    jQuery("#shopify-section-1590575979720 video").attr('title', 'Dreame V11 SPACE 4.0 High-speed motor (25000 Pa, 125000RPM)');
  	jQuery("#shopify-section-1600955577990 video").attr('title', 'Dreame T20 - Leading the Cordless Vacuum Cleaner Market');
  	
  	jQuery("#shopify-section-1591775439358 .image-element__wrap").attr('role', 'img');
  	jQuery("#shopify-section-1591776799134 .image-element__wrap").attr('role', 'img');
  	jQuery("#template-product-dreame-f9 .front .image-element__wrap").attr('role', 'img');
  	jQuery("#template-product-dreame-f9 .back .image-element__wrap").attr('role', 'img');
  	jQuery("#template-product-v11-dreametime .front .image-element__wrap").attr('role', 'img');
  	jQuery("#template-product-v11-dreametime .back .image-element__wrap").attr('role', 'img');
  	jQuery("#shopify-section-1591690886671 .image-element__wrap").attr('role', 'img');
  	jQuery("#shopify-section-1591690886671 .image-element__wrap").attr('aria-label', 'Dreame F9 robot vauum - Pioneer 2.0 - Powerful intelligent. Completely clean');
	jQuery("#shopify-section-1591775439358 .image-element__wrap").attr('aria-label', 'Dreame F9 200mL intelligent electric water tank');
	jQuery("#shopify-section-1591776799134 .image-element__wrap").attr('aria-label', 'Dreame F9 microfiber anti-bacterial flexible mop');
	
  	jQuery("#shopify-section-1600956370680 .image-element__wrap").attr('role', 'img');
  	jQuery("#shopify-section-1600956370680 .image-element__wrap").attr('aria-label', 'Dreame T20 - Leading the Cordless Vacuum Cleaner Market');
	
  	jQuery("#shopify-section-1600978896940 .front .image-element__wrap").attr('aria-label', 'Dreame T20 floor cleaning');
	jQuery("#shopify-section-1600979165718 .front .image-element__wrap").attr('aria-label', 'Dreame T20 furniture dusting');
	jQuery("#shopify-section-1600979286575 .front .image-element__wrap").attr('aria-label', 'Dreame T20 mites elimination');
	jQuery("#shopify-section-1600979447350 .front .image-element__wrap").attr('aria-label', 'Dreame T20 hard-to-reach area cleaning');
	jQuery("#shopify-section-1601056160070 .front .image-element__wrap").attr('aria-label', 'Dreame T20 small area cleaning');
	
  	jQuery("#shopify-section-1600978896940 .back .image-element__wrap").attr('aria-label', 'Dreame T20 floor cleaning');
	jQuery("#shopify-section-1600979165718 .back .image-element__wrap").attr('aria-label', 'Dreame T20 furniture dusting');
	jQuery("#shopify-section-1600979286575 .back .image-element__wrap").attr('aria-label', 'Dreame T20 mites elimination');
	jQuery("#shopify-section-1600979447350 .back .image-element__wrap").attr('aria-label', 'Dreame T20 hard-to-reach area cleaning');
	jQuery("#shopify-section-1601056160070 .back .image-element__wrap").attr('aria-label', 'Dreame T20 small area cleaning');
	
  	jQuery("#shopify-section-1590563683661 .front .image-element__wrap").attr('aria-label', 'Dreame V11 aviation-level motor');
	jQuery("#shopify-section-1590564158482 .front .image-element__wrap").attr('aria-label', 'Dreame V11 all-in-one OLED display');
	jQuery("#shopify-section-1590564298116 .front .image-element__wrap").attr('aria-label', 'Dreame V11 PAC motor efficiency-increased system');
	jQuery("#shopify-section-1590565196853 .front .image-element__wrap").attr('aria-label', 'Dreame V11 7-stage noise reduction');
	
  	jQuery("#shopify-section-1590563683661 .back .image-element__wrap").attr('aria-label', 'Dreame V11 aviation-level motor');
	jQuery("#shopify-section-1590564158482 .back .image-element__wrap").attr('aria-label', 'Dreame V11 all-in-one OLED display');
	jQuery("#shopify-section-1590564298116 .back .image-element__wrap").attr('aria-label', 'Dreame V11 PAC motor efficiency-increased system');
	jQuery("#shopify-section-1590565196853 .back .image-element__wrap").attr('aria-label', 'Dreame V11 7-stage noise reduction');
	
  	jQuery("#shopify-section-1590571346518 .front .image-element__wrap").attr('aria-label', 'Dreame V11 soft cashmere roller brush for clean the floors/carpet');
	jQuery("#shopify-section-1590572278388 .front .image-element__wrap").attr('aria-label', 'Dreame V11 mite-removal brush for clean the bedding/fabrics');
	jQuery("#shopify-section-1590572376500 .front .image-element__wrap").attr('aria-label', 'Dreame V11 2-in-1 brush for clean the furniture');
	jQuery("#shopify-section-1590572906239 .front .image-element__wrap").attr('aria-label', 'Dreame V11 2-in-1 flat brush for clean the narrow gaps');
	
  	jQuery("#shopify-section-1590571346518 .back .image-element__wrap").attr('aria-label', 'Dreame V11 soft cashmere roller brush for clean the floors/carpet');
	jQuery("#shopify-section-1590572278388 .back .image-element__wrap").attr('aria-label', 'Dreame V11 mite-removal brush for clean the bedding/fabrics');
	jQuery("#shopify-section-1590572376500 .back .image-element__wrap").attr('aria-label', 'Dreame V11 2-in-1 brush for clean the furniture');
	jQuery("#shopify-section-1590572906239 .back .image-element__wrap").attr('aria-label', 'Dreame V11 2-in-1 flat brush for clean the narrow gaps');
	
  	jQuery("#shopify-section-1591700958390 .front .image-element__wrap").attr('aria-label', 'Dreame F9 0.1mm flexible microfiber roller brush');
	jQuery("#shopify-section-1591701834845 .front .image-element__wrap").attr('aria-label', 'Dreame F9 high-speed 190rpm side brush');
	jQuery("#shopify-section-1591702253574 .front .image-element__wrap").attr('aria-label', 'Dreame F9 two-layer dustbin and filtration system');
	jQuery("#shopify-section-1591702952939 .front .image-element__wrap").attr('aria-label', 'Dreame F9 large capacity dustbin of 600ml');
	
  	jQuery("#shopify-section-1591700958390 .back .image-element__wrap").attr('aria-label', 'Dreame F9 0.1mm flexible microfiber roller brush');
	jQuery("#shopify-section-1591701834845 .back .image-element__wrap").attr('aria-label', 'Dreame F9 high-speed 190rpm side brush');
	jQuery("#shopify-section-1591702253574 .back .image-element__wrap").attr('aria-label', 'Dreame F9 two-layer dustbin and filtration system');
	jQuery("#shopify-section-1591702952939 .back .image-element__wrap").attr('aria-label', 'Dreame F9 large capacity dustbin of 600ml');
	
  	jQuery("#shopify-section-1590219117610 .front .image-element__wrap").attr('aria-label', 'Dreame V9 two-in-one brush for fabrics cleaning');
	jQuery("#shopify-section-1590219241025 .front .image-element__wrap").attr('aria-label', 'Dreame V9 mite removal brush for bedding cleaning');
	jQuery("#shopify-section-1590219478918 .front .image-element__wrap").attr('aria-label', 'Dreame V9 soft cashmere turbine brush for floor and carpets cleaning');
	jQuery("#shopify-section-1590219578577 .front .image-element__wrap").attr('aria-label', 'Dreame V9 electric mite removal for gaps cleaning');
	
  	jQuery("#shopify-section-1590219117610 .back .image-element__wrap").attr('aria-label', 'Dreame V9 two-in-one brush for fabrics cleaning');
	jQuery("#shopify-section-1590219241025 .back .image-element__wrap").attr('aria-label', 'Dreame V9 mite removal brush for bedding cleaning');
	jQuery("#shopify-section-1590219478918 .back .image-element__wrap").attr('aria-label', 'Dreame V9 soft cashmere turbine brush for floor and carpets cleaning');
	jQuery("#shopify-section-1590219578577 .back .image-element__wrap").attr('aria-label', 'Dreame V9 electric mite removal for gaps cleaning');
	
  	jQuery("#shopify-section-1590230340821 .front .image-element__wrap").attr('aria-label', 'Dreame V10 soft cashmere turbine brush');
	jQuery("#shopify-section-1590230429422 .front .image-element__wrap").attr('aria-label', 'Dreame V10 electric mite removal brush');
	jQuery("#shopify-section-1590230520107 .front .image-element__wrap").attr('aria-label', 'Dreame V10 two-in-one brush');
	jQuery("#shopify-section-1590230611862 .front .image-element__wrap").attr('aria-label', 'Dreame V10 two-in-one flat brush');
	
  	jQuery("#shopify-section-1590230340821 .back .image-element__wrap").attr('aria-label', 'Dreame V10 soft cashmere turbine brush for floors and carpets cleaning');
	jQuery("#shopify-section-1590230429422 .back .image-element__wrap").attr('aria-label', 'Dreame V10 electric mite removal brush for bedding cleaing');
	jQuery("#shopify-section-1590230520107 .back .image-element__wrap").attr('aria-label', 'Dreame V10 two-in-one brush for fabrics cleaning');
	jQuery("#shopify-section-1590230611862 .back .image-element__wrap").attr('aria-label', 'Dreame V10 two-in-one flat brush for narrow gaps cleaning');
	
  	jQuery("#shopify-section-9da9bd66-e153-4762-a70e-54b78bdcb66d").attr('role', 'img');
  	jQuery("#shopify-section-9da9bd66-e153-4762-a70e-54b78bdcb66d").attr('aria-label', 'Dreame D9 can schedule cleans when you are not home');
  
  	jQuery("#shopify-section-product_V10_Boreas .image-element__wrap").attr('role', 'img');
  	jQuery("#shopify-section-1590225564117 .image-element__wrap").attr('aria-label', 'Dreame V10 boreas cordless vacuum cleaner - Benchmark of the industry');
	
  	jQuery("#shopify-section-product_V9_Cleaner .image-element__wrap").attr('role', 'img');
  	jQuery("#shopify-section-1590174110427 .image-element__wrap").attr('aria-label', 'Dreame V9 Cordless Stick Vacuum');
	
  	jQuery("#shopify-section-1590217028934 .tabs_bar .tab-content").attr('role', 'img');
  	jQuery("#shopify-section-1590217028934 .tabs_bar #tab-1").attr('aria-label', 'Dreame V9 long battery life');
  	jQuery("#shopify-section-1590217028934 .tabs_bar #tab-2").attr('aria-label', 'Dreame V9 smart air cooling system guarantees long lasting battery');
  	jQuery("#shopify-section-1590217028934 .tabs_bar #tab-3").attr('aria-label', 'Dreame V9 multi-clone cyclone separation technology ensures longer strong suction');
  
  	jQuery( ".sub-blocks" ).each(function() {
    	jQuery(this).insertAfter(jQuery(this).parents('.image-with-text-overlay__container').find("h2.image-with-text-overlay__heading"));
    });
	
	jQuery('ul.tabs li').click(function(){
		var tab_id = jQuery(this).attr('data-tab');

		jQuery('ul.tabs li').removeClass('current');
		jQuery('.tab-content').removeClass('current');

		jQuery(this).addClass('current');
		jQuery("#"+tab_id).addClass('current');
	});
  
  	jQuery('a#f_div').click(function(){
      	jQuery(document).find('.lcd_screen ul li a').removeClass("active");
      	jQuery(this).addClass("active");
      	console.log("ss");
        jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-97.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-97.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('data-src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-97.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-97.webp?v=1753427429');
		return false;
    });
  	jQuery('a#s_div').click(function(){
      	jQuery(document).find('.lcd_screen ul li a').removeClass("active");
      	jQuery(this).addClass("active");
      	console.log("ss2");
      	jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-94.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-94.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('data-src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-94.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-94.webp?v=1753427429');
		return false;
    });
  	jQuery('a#t_div').click(function(){
      	jQuery(document).find('.lcd_screen ul li a').removeClass("active");
      	jQuery(this).addClass("active");
      	console.log("ss3");
      	jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-95.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-95.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('data-src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-95.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-95.webp?v=1753427429');
		return false;
    });
  	jQuery('a#fourth_div').click(function(){
      	jQuery(document).find('.lcd_screen ul li a').removeClass("active");
      	jQuery(this).addClass("active");
      	console.log("ss4");
      	jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-96.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-96.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('data-src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-96.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-96.webp?v=1753427429');
		return false;
    });
  	jQuery('a#fitth_div').click(function(){
      	jQuery(document).find('.lcd_screen ul li a').removeClass("active");
      	jQuery(this).addClass("active");
      	console.log("ss5");
      	jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-98.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-98.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('data-src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-98.webp?v=1753427429');
   		jQuery("#shopify-section-1601064046277 .image-element__wrap img").attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/Mask-Group-98.webp?v=1753427429');
		return false;
    });
    
  	if (window.matchMedia('screen and (max-width: 767px)').matches) {
      
      jQuery('.panel-heading a').click(function(){
        jQuery(this).parents().find("#accordion .panel").removeClass("active");
        jQuery(this).parent().parent().addClass("active");
        return false;
      });
      
      jQuery('.image-element__wrap').click(function(){
          jQuery(this).parents().find('.dots-hover-text-column').css('display', 'none');
      });
      jQuery('.image-with-text-overlay__banner').click(function(){
          jQuery(this).parents().find('.plus-hover-container span').css('color', 'transparent');
          jQuery(this).parents().find('.plus-hover-container span').removeClass('openColor');
      });
      jQuery('.plus-hover-container span').click(function(){
          jQuery(this).parents().find('.plus-hover-container span').css('color', 'transparent');
          jQuery(this).parents().find('.plus-hover-container span').removeClass('openColor');
          if(jQuery(this).hasClass( "dot2" )) {
            jQuery(this).toggleClass('openColor');
          }else if(jQuery(this).hasClass( "dot3" )) {
//           	jQuery(this).css('color', '#4087dc');
         	jQuery(this).parents().find("#shopify-section-1590557338025 span.dot3").css('color', '#4087dc');
            jQuery(this).parents().find("#shopify-section-1590226348157 span.dot3").css('color', '#fff');
          }else if(jQuery(this).hasClass( "dot4" )) {
//           	jQuery(this).css('color', '#4087dc');
            jQuery(this).parents().find("#shopify-section-1590557338025 span.dot4").css('color', '#4087dc');
            jQuery(this).parents().find("#shopify-section-1590226348157 span.dot4").css('color', '#fff');
          }else{
          	jQuery(this).css('color', '#fff');
          }
      });
      jQuery('.dots-hover-container span').click(function(){
          jQuery(this).parents().find('.dots-hover-text-column').css('display', 'none');
          jQuery(this).find('.dots-hover-text-column').css('display', 'block');
      });

//       jQuery( document ).ready(function() {
		jQuery("#shopify-section-1591699755509 .image-element__wrap img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/t/7/assets/compress_img.jpg?v=1593113545');
   		jQuery("#shopify-section-1591699755509 .image-element__wrap img").attr('srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/t/7/assets/compress_img.jpg?v=1593113545');
   		jQuery("#shopify-section-1591699755509 .image-element__wrap img").attr('data-src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/t/7/assets/compress_img.jpg?v=1593113545');
   		jQuery("#shopify-section-1591699755509 .image-element__wrap img").attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/t/7/assets/compress_img.jpg?v=1593113545');
//    	});
      
      // If element is scrolled into view, fade it in
      jQuery(window).scroll(function() {
        jQuery("body .animated").each(function() {
          if (isScrolledIntoView(this) === true) {
//             setTimeout(function() {
//                jQuery(this).parents().find(".animated").removeClass("go");
//             }, 500); 
            jQuery(this).addClass("go");
          }
        });
      });
      
      
      jQuery( document ).ready(function() {
        jQuery("#shopify-section-1590174110427").find(".animated").addClass("go");
        jQuery("#shopify-section-1590566327262").find(".animated").addClass("go");
        jQuery("#shopify-section-1590530612564").find(".animated").addClass("go");
        jQuery("#shopify-section-1590225564117").find(".animated").addClass("go");
        jQuery("#shopify-section-1591690886671").find(".animated").addClass("go");
      });

//       jQuery( window ).scroll(function() {
//         var hH = $('#bg_bar').outerHeight(),
//             wH = $(window).height(),
//             wS = $(this).scrollTop();
//         var d = document.getElementById("bg_bar");
// 		var hT = d.offsetTop;
//         console.log(hT);
//         console.log(hH);
//         console.log(wH);
//         console.log(wS);
//         if (wS > hT) {
//           if(wS > 1600){
//             jQuery(".pro_bar").removeClass('fixed_blk');
//           }else{
//             jQuery(".pro_bar").addClass('fixed_blk');
//           }
//         }else{
//           jQuery(".pro_bar").removeClass('fixed_blk');

//         }
//      });
      
      
      jQuery('#mapping a').click(function(){
        if (jQuery(this).hasClass('cliked')) {
          jQuery(this).text('Mapping');
          jQuery(this).removeClass('cliked');
          jQuery(this).parents().find(".img_blk_main").hide();
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-maping_1600x.jpg');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-maping_1600x.jpg');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('data-src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-maping_1600x.jpg');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-maping_1600x.jpg');
        }else{
          jQuery(this).text('Normal');
          jQuery(this).addClass('cliked'); 
          jQuery(this).parents().find(".img_blk_main").show();
          jQuery(this).parents().find(".img_blk_main img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/t/29/assets/SC1-block.png?v=1592894038');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-hover.jpg?v=1753156245');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-hover.jpg?v=1753156245');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('data-src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-hover.jpg?v=1753156245');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-hover.jpg?v=1753156245');
        }  
        return false;
      });
  		
      jQuery("#slides_bar2 input:radio:first").prop("checked", true).trigger("click");
    }else{
  
      // If element is scrolled into view, fade it in
      jQuery(window).scroll(function() {
        jQuery("body .animated").each(function() {
          if (isScrolledIntoView(this) === true) {
            jQuery(this).parents().find(".animated").removeClass("go");
            jQuery(this).addClass("go");
          }
        });
      });
      
      jQuery('#mapping a').hover(function(){
        if (jQuery(this).hasClass('cliked')) {
          var attr = jQuery("body").attr('data-current-lang');
          console.log(attr);
          if(attr == 'ru'){
          	jQuery(this).text('Построение карт');
          }else if(attr == 'de'){
          	jQuery(this).text('Kartenerstellung');
          }else if(attr == 'es'){
          	jQuery(this).text('Mapeo');
          }else if(attr == 'fr'){
          	jQuery(this).text('Cartographie');
          }else{
          	jQuery(this).text('Mapping');
          }
          jQuery(this).removeClass('cliked');
          jQuery(this).parents().find(".img_blk_main").hide();
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-maping_1600x.jpg?v=1593154152');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-maping_1600x.jpg?v=1593154152');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('data-src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-maping_1600x.jpg?v=1593154152');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-maping_1600x.jpg?v=1593154152');
          return false;
        }else{
          var attr = jQuery("body").attr('data-current-lang');
          console.log(attr);
          if(attr == 'ru'){
          	jQuery(this).text('Регулярное');
          }else{
          	jQuery(this).text('Normal');
          }                      
          jQuery(this).addClass('cliked');
          jQuery(this).parents().find(".img_blk_main").show();
          jQuery(this).parents().find(".img_blk_main img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/t/29/assets/SC1-block.png?v=1592894038');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-hover.jpg?v=1753156245');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-hover.jpg?v=1753156245');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('data-src', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-hover.jpg?v=1753156245');
          jQuery(this).parents().find("#shopify-section-1591708149949 .image-element__wrap img").attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0302/5276/1220/files/SC12-hover.jpg?v=1753156245');
          return false;
        }
      });
      
      
      jQuery( document ).ready(function() {
        jQuery("#shopify-section-1590174110427").find(".animated").addClass("go");
        jQuery("#shopify-section-1590566327262").find(".animated").addClass("go");
        jQuery("#shopify-section-1590530612564").find(".animated").addClass("go");
        jQuery("#shopify-section-1590225564117").find(".animated").addClass("go");
        jQuery("#shopify-section-1591690886671").find(".animated").addClass("go");
      });
      
//       jQuery( window ).scroll(function() {
//         var hH = $('#bg_bar').outerHeight(),
//             wH = $(window).height(),
//             wS = $(this).scrollTop();
//         var d = document.getElementById("bg_bar");
// 		var hT = d.offsetTop;
//         console.log(hT);
//         console.log(hH);
//         console.log(wH);
//         console.log(wS);
//         if (wS > hT) {
//           if(wS > 1400){
//             jQuery(".pro_bar").removeClass('fixed_blk');
//           }else{
//             jQuery(".pro_bar").addClass('fixed_blk');
//           }
//         }else{
//           jQuery(".pro_bar").removeClass('fixed_blk');

//         }
//      });
      jQuery("#slides_bar input:radio:first").prop("checked", true).trigger("click");
    }
    
  	// Check if element is scrolled into view
    function isScrolledIntoView(elem) {
      var docViewTop = jQuery(window).scrollTop();
      var docViewBottom = docViewTop + jQuery(window).height();

      var elemTop = jQuery(elem).offset().top;
      var elemBottom = elemTop + jQuery(elem).height();

      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }
  
  	jQuery('.dropdown_bar a[data-toggle="dropdown"]').click(function(){
      //console.log("s");
      jQuery(this).parents().find('a[data-toggle="dropdown"]').show();
      jQuery(this).hide();
      jQuery(this).parents().find('.dropdown-menu').removeClass("show");
      jQuery(this).parent().find('.dropdown-menu').addClass("show");
      return false;
    });
  
  var pathname = window.location.pathname;
  var pname = pathname.split("/");
  if(pname[1] == 'es'){
  	jQuery("#ru").after('<div class="ht-tms-dropdown__list-item"><a href="https://kr.dreame-technology.com'+ pathname.slice(3) +'"><img src="https://cdn.shopify.com/s/files/1/0553/0950/0595/t/2/assets/255px-Flag_of_South_Korea.svg.png"><span class="ht-tms-dropdown__list-item__label" style="width: 66px !important;position: relative;top: -5px;left: 10px;color: #111;">Korean</span></a></div><div class="ht-tms-dropdown__list-item"><a href="https://us.dreame-technology.com'+ pathname.slice(3) +'"><img src="https://cdn.shopify.com/s/files/1/0302/5276/1220/t/17/assets/us_flag.png"><span class="ht-tms-dropdown__list-item__label" style="width: 66px !important;position: relative;top: -5px;left: 10px;color: #111;">United States</span></a></div>');
  }else if(pname[1] == 'ja' || pname[1] == 'ru' || pname[1] == 'fr' || pname[1] == 'de'){
  	jQuery("#es").after('<div class="ht-tms-dropdown__list-item"><a href="https://kr.dreame-technology.com'+ pathname.slice(3) +'"><img src="https://cdn.shopify.com/s/files/1/0553/0950/0595/t/2/assets/255px-Flag_of_South_Korea.svg.png"><span class="ht-tms-dropdown__list-item__label" style="width: 66px !important;position: relative;top: -5px;left: 10px;color: #111;">Korean</span></a></div><div class="ht-tms-dropdown__list-item"><a href="https://us.dreame-technology.com'+ pathname.slice(3) +'"><img src="https://cdn.shopify.com/s/files/1/0302/5276/1220/t/17/assets/us_flag.png"><span class="ht-tms-dropdown__list-item__label" style="width: 66px !important;position: relative;top: -5px;left: 10px;color: #111;">United States</span></a></div>');
  }else{
  	jQuery("#es").after('<div class="ht-tms-dropdown__list-item"><a href="https://kr.dreame-technology.com'+ pathname +'"><img src="https://cdn.shopify.com/s/files/1/0553/0950/0595/t/2/assets/255px-Flag_of_South_Korea.svg.png"><span class="ht-tms-dropdown__list-item__label" style="width: 66px !important;position: relative;top: -5px;left: 10px;color: #111;">Korean</span></a></div><div class="ht-tms-dropdown__list-item"><a href="https://us.dreame-technology.com'+ pathname +'"><img src="https://cdn.shopify.com/s/files/1/0302/5276/1220/t/17/assets/us_flag.png"><span class="ht-tms-dropdown__list-item__label" style="width: 66px !important;position: relative;top: -5px;left: 10px;color: #111;">United States</span></a></div>');
  }
  
  //jQuery("#shopify-section-4d4149e6-a940-4eb5-a6af-d6a1c2428f39 .image-with-text-overlay__buttons").after('<div><p style="font-size:14px !important;">*Do not forget getting €17 store coupon in the page!<br/>*The prices in euro are subject to change depending on the exchange rate of all aliexpress.</p></div>');
  
});


$(document).ready(function(){
    getFunction();
})
$(window).resize(function(){
    getFunction();
})
      function getFunction(){
      // build scene
      // init controller
        
        
        if($('.pbir-item-56965e5c-2514-4906-a87a-9db3adf6da48').offset()){
        
      
      let pmshc_el= $('.pbir-item-56965e5c-2514-4906-a87a-9db3adf6da48'), pmshc_el_height=pmshc_el.outerHeight(true),
     pmshc_el_offset=pmshc_el.offset().top,
     pmshc_el_offset_top=169;
    //  console.log(pmshc_el_offset);
    //  var beishu_nine = $(window).width()/1920;
            
    //         var n_beshu = beishu_nine*400;
     var controller = new ScrollMagic.Controller();
      var t = new TimelineMax();

       t.add(TweenLite.fromTo(".pbir-item-56965e5c-2514-4906-a87a-9db3adf6da48 .image-box .image", 100, { css: { opacity: "0.6" }}, { css: { opacity: "1" } , ease:Power2.easeInOut}))
         var scene="";
       if($(window).width()>820){
        scene = new ScrollMagic.Scene({ triggerElement: ".pbir-item-56965e5c-2514-4906-a87a-9db3adf6da48", duration: pmshc_el_height/3})
          .setTween(t)
          .addTo(controller); 
         
       }
        else{
            scene = new ScrollMagic.Scene({ triggerElement: ".pbir-item-56965e5c-2514-4906-a87a-9db3adf6da48", duration: pmshc_el_height/2, offset:$(window).height()*1/20})
          .setTween(t)
         
          .addTo(controller); 
         
        }
  };
          }



    $(window).scroll(function(){
     
      let that=".pbir-item-bf6cabdc-4b1c-44f8-9c0f-7bb2bfa5104d"||'';
      if($(that).offset()){
    
            if($(window).scrollTop() +($(window).height())-60  > $(that).offset().top){
           
            
              $(that).find('.animate-spc-js.btwi-li-3').addClass("animated");    
              $('.pbir-item-bf6cabdc-4b1c-44f8-9c0f-7bb2bfa5104d .btwi-ul span.number-3').leoTextAnimate({delay:1500,fixed:[',',':','.'],start:'0'});
              $('.pbir-item-bf6cabdc-4b1c-44f8-9c0f-7bb2bfa5104d .btwi-ul span.number-2').leoTextAnimate({delay:2000,fixed:[',',':','.'],start:'0'});
              $('.pbir-item-bf6cabdc-4b1c-44f8-9c0f-7bb2bfa5104d .btwi-ul span.number-1').leoTextAnimate({delay:2500,fixed:[',',':','.'],start:'0'});

              setTimeout(()=>{
                $(that).find('.animate-spc-js.btwi-li-2').addClass("animated");    
              },1400);
              setTimeout(()=>{
                $(that).find('.animate-spc-js.btwi-li-1').addClass("animated");    
              },1900)
             
  }  
  else{
    let that=this;
    $(that).find('.animate-spc-js').removeClass("animated");    
    $('.pbir-item-bf6cabdc-4b1c-44f8-9c0f-7bb2bfa5104d .btwi-ul span.number-3').leoTextAnimate('reload', {
      text: '7.5',
      delay: 1500,
      autorun: true,
      fixed: [',', ':', '.'],
      start: '0'
  });
  $('.pbir-item-bf6cabdc-4b1c-44f8-9c0f-7bb2bfa5104d .btwi-ul span.number-2').leoTextAnimate('reload', {
    text: '35',
    delay: 2000,
    autorun: true,
    fixed: [',', ':', '.'],
    start: '0'
});
$('.pbir-item-bf6cabdc-4b1c-44f8-9c0f-7bb2bfa5104d .btwi-ul span.number-1').leoTextAnimate('reload', {
  text: '90',
  delay: 2500,
  autorun: true,
  fixed: [',', ':', '.'],
  start: '0'
});
  } 
    }
})